import React from 'react';
import styled from '@emotion/styled';
import { Chip, ITheme, StyledBaseChip, StyledChip } from '../../../ui';
import { StatusLabel, StyledStatus } from '../../flights/shared/status/ui';

const ChipSection = styled.div<{}, ITheme>`
	& + & {
		margin-top: 24px;
	}

	${StyledStatus} + ${StyledStatus},
	${StyledChip} + ${StyledChip} {
		margin-left: 8px;
	}
`;

export const Chips = () => (
	<>
		<h2 id="chips">Chips</h2>
		<ChipSection>
			<h3>Variations</h3>
			<StyledBaseChip>base</StyledBaseChip>
			<Chip variation="light">default</Chip>
			<Chip variation="light">light</Chip>
			<Chip variation="highlight">highlight</Chip>
			<Chip variation="brand">brand</Chip>
			<Chip variation="error">error</Chip>
		</ChipSection>
		<ChipSection>
			<h3>Flight status labels</h3>
			<StatusLabel status="Arrived" />
			<StatusLabel status="Arriving" />
			<StatusLabel status="Boarding" />
			<StatusLabel status="Canceled" />
			<StatusLabel status="Cancelled" />
			<StatusLabel status="Closed" />
			<StatusLabel status="Customs" />
			<StatusLabel status="Delayed" />
			<StatusLabel status="Departed" />
			<StatusLabel status="Landed" />
			<StatusLabel status="On Time" />
			<div>
				<small>
					NB: both the status &quot;Canceled&quot; as well as
					&quot;Cancelled&quot; are supported, both using the same translation
					as display value, and therefore appearing twice in the list above.
				</small>
			</div>
		</ChipSection>
	</>
);
